var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Modules, nameGeolocalisation } from '../services/utils/format';
import * as ServiceUtils from '../services/utils';
import { Stack, Chip } from '@mui/material';
import { Button } from './Button';
import { CardTitle } from './CardTitle';
import { Typography } from './Typography';
import { AddIcon, RefreshIcon, SearchIcon, CloseIcon, ClientIcon, CollaborateurIcon, AffaireIcon, ActiviteIcon, } from './Icons';
import { FormikGenerator, TYPES } from './FormikGenerator';
import { IconButton } from './IconButton';
import { InputAutoCompleteAdresse } from './InputAutoCompleteAdresse';
import { getFiltres, postUpdateFiltres } from '../services/utilisateur';
import { formatDate } from '../services/utils/utils';
export var convertFiltresToResults = function (filtres) {
    var results = {};
    for (var _i = 0, _a = Object.entries(filtres); _i < _a.length; _i++) {
        var filtre = _a[_i];
        var name_1 = filtre[0], datas = filtre[1];
        if (name_1 === nameGeolocalisation) {
            results.AdresseComplete = datas.AdresseComplete;
            results.Distance = datas.Distance ? datas.Distance : 0;
            results.PosLatitude = datas.PosLatitude;
            results.PosLongitude = datas.PosLongitude;
        }
        else {
            results[name_1] = Array.isArray(datas)
                ? datas.map(function (data) { return data.value; })
                : datas;
        }
    }
    return results;
};
export var FiltresV2 = function (_a) {
    var title = _a.title, Type = _a.Type, handleSearch = _a.handleSearch, _b = _a.color, color = _b === void 0 ? 'primary' : _b;
    var Formats = {};
    Object.entries(Modules[Type]).map(function (_a) {
        var name = _a[0], format = _a[1];
        if (format.datePicker || format.datetimePicker) {
            Formats[name + 'Min'] = __assign(__assign({}, format), { name: name + 'Min', libelle: format.libelle + ' du' });
            Formats[name + 'Max'] = __assign(__assign({}, format), { name: name + 'Max', libelle: format.libelle + " jusqu'au" });
        }
        else {
            Formats[name] = __assign(__assign({}, format), { name: name });
        }
    });
    var _c = useState(false), isSubmitting = _c[0], setIsSubmitting = _c[1];
    var _d = useState(getFiltres(Type)), filtres = _d[0], setFiltres = _d[1];
    var _e = useState([]), selectList = _e[0], setSelectList = _e[1];
    var handleSubmit = function () {
        setIsSubmitting(true);
        handleSearch(convertFiltresToResults(filtres));
        postUpdateFiltres(Type, filtres);
        setIsSubmitting(false);
    };
    var updateSelectListe = function (filtre, data) {
        var newSelectList = __assign({}, selectList);
        newSelectList[filtre] = data;
        setSelectList(newSelectList);
    };
    var getData = function (filtreName) {
        var idsearch = null;
        if (selectList[filtreName]) {
            return;
        }
        if (filtreName.includes('TypeId')) {
            idsearch = filtreName.replace('TypeId', '');
            ServiceUtils.getTypes(idsearch).then(function (response) {
                updateSelectListe(filtreName, response);
            });
        }
        else if (filtreName == 'Tags') {
            ServiceUtils.getTypes('Tag').then(function (response) {
                updateSelectListe(filtreName, response);
            });
        }
        else {
            ServiceUtils.getListe(Type, filtreName).then(function (response) {
                updateSelectListe(filtreName, response);
            });
        }
    };
    var handleAddFiltre = function (values) {
        var name = values.filtreName;
        var isArray = Array.isArray(values[name]);
        var datas = isArray
            ? values[values.filtreName + '__options']
            : values[values.filtreName];
        setFiltres(function (prevState) {
            if (!prevState[name]) {
                prevState[name] = isArray ? [] : '';
            }
            if (name === nameGeolocalisation) {
                prevState[name] = {
                    AdresseComplete: values.AdresseComplete,
                    Distance: values.Distance ? values.Distance : 0,
                    PosLatitude: values.PosLatitude,
                    PosLongitude: values.PosLongitude,
                };
            }
            else {
                prevState[name] = isArray ? __spreadArray(__spreadArray([], prevState[name], true), datas, true) : datas;
            }
            return prevState;
        });
    };
    var handleRemoveFiltre = function (name) {
        setFiltres(function (prevState) {
            var newState = __assign({}, prevState);
            delete newState[name];
            return newState;
        });
    };
    var handleDeleteOnlyOne = function (name, valueDeleted) {
        setFiltres(function (prevState) {
            var newState = __assign({}, prevState);
            newState[name] = newState[name].filter(function (_a) {
                var value = _a.value;
                return value !== valueDeleted;
            });
            if (newState[name].length === 0) {
                delete newState[name];
            }
            return newState;
        });
    };
    var iconTitle = null;
    switch (Type) {
        case 'Collaborateur':
            iconTitle = _jsx(CollaborateurIcon, {});
            break;
        case 'Client':
            iconTitle = _jsx(ClientIcon, {});
            break;
        case 'Affaire':
            iconTitle = _jsx(AffaireIcon, {});
            break;
        case 'Activite':
            iconTitle = _jsx(ActiviteIcon, {});
            break;
        default:
            break;
    }
    return (_jsxs(Stack, { children: [_jsx(CardTitle, { title: title, color: color, startIcon: iconTitle, withFileAriane: true }), _jsx(FormikGenerator, { datas: {}, fields: [], renderContent: function (_a) {
                    var values = _a.values, renderField = _a.renderField, setFieldValue = _a.setFieldValue;
                    var filtreSelected = values.filtreName
                        ? Formats[values.filtreName]
                        : null;
                    return (_jsxs(Stack, __assign({ spacing: 2, className: "mt-small" }, { children: [_jsxs(Stack, __assign({ direction: "row", spacing: 2, alignItems: "end" }, { children: [_jsx(IconButton, __assign({ size: "small", tooltip: "Vider les filtres", onClick: function () { return setFiltres({}); } }, { children: _jsx(RefreshIcon, {}) })), _jsx(Stack, __assign({ sx: { minWidth: 200 } }, { children: renderField({
                                            label: 'Ajouter filtre',
                                            name: 'filtreName',
                                            type: TYPES.SELECT,
                                            options: Object.values(Formats).map(function (filtre) { return ({
                                                value: filtre.name,
                                                label: filtre.libelle,
                                            }); }),
                                            afterChange: function (value) {
                                                var newFiltreSelected = value ? Formats[value] : null;
                                                if (newFiltreSelected &&
                                                    newFiltreSelected.type === TYPES.SELECT) {
                                                    getData(value);
                                                }
                                            },
                                        }) })), filtreSelected ? (_jsx(_Fragment, { children: filtreSelected.type === 'geolocalisation' ? (_jsxs(Stack, __assign({ direction: "row", spacing: 2 }, { children: [_jsx(Stack, __assign({ sx: { minWidth: 400 } }, { children: _jsx(InputAutoCompleteAdresse, { onChange: function (adresse) {
                                                            setFieldValue('AdresseComplete', [
                                                                adresse.Adresse,
                                                                adresse.CodePostal,
                                                                adresse.Ville,
                                                            ]
                                                                .filter(function (value) { return value; })
                                                                .join(' '));
                                                            setFieldValue('PosLatitude', adresse.Latitude);
                                                            setFieldValue('PosLongitude', adresse.Longitude);
                                                        } }) })), _jsx(Stack, __assign({ sx: { minWidth: 50 } }, { children: renderField({
                                                        label: 'Distance (km)',
                                                        name: 'Distance',
                                                        type: TYPES.TEXT,
                                                        onlyDigits: true,
                                                    }) }))] }))) : (_jsx(Stack, __assign({ sx: { minWidth: 200 } }, { children: renderField(__assign(__assign({ label: "\"".concat(filtreSelected.libelle, "\" recherch\u00E9(e)") }, filtreSelected), { multiple: filtreSelected.type === TYPES.SELECT, options: selectList[filtreSelected.name]
                                                    ? selectList[filtreSelected.name]
                                                    : [] })) }))) })) : (_jsx(_Fragment, {})), _jsx(Stack, { children: _jsx(Button, __assign({ disabled: !filtreSelected ||
                                                (filtreSelected.type === 'geolocalisation' &&
                                                    !values.PosLatitude &&
                                                    !values.PosLatitude &&
                                                    !values.Distance) ||
                                                (filtreSelected.type !== 'geolocalisation' &&
                                                    !values[values.filtreName]), size: "small", type: "submit", tooltip: "Ajouter", startIcon: _jsx(AddIcon, {}) }, { children: "Ajouter le(s) filtre(s)" })) })] })), _jsx(Stack, __assign({ spacing: 2 }, { children: Object.entries(filtres).map(function (_a) {
                                    var name = _a[0], filtresRow = _a[1];
                                    var format = Formats[name];
                                    return (_jsxs(Stack, __assign({ direction: "row", alignItems: "center", spacing: 2 }, { children: [_jsx(IconButton, __assign({ tooltip: "Supprimer les filtres", color: "error", size: "small", onClick: function () { return handleRemoveFiltre(name); } }, { children: _jsx(CloseIcon, { fontSize: "small" }) })), _jsx(Typography, __assign({ className: "bold" }, { children: "".concat(format && format.libelle ? format.libelle : '', " : ") })), name === nameGeolocalisation ? (_jsx(_Fragment, { children: _jsxs(Typography, { children: [filtresRow.AdresseComplete, " (", filtresRow.Distance, ' ', "km)"] }) })) : (_jsx(_Fragment, { children: Array.isArray(filtresRow) ? (filtresRow.map(function (_a) {
                                                    var label = _a.label, value = _a.value;
                                                    return (_jsx(Chip, { label: label, onDelete: function () {
                                                            return handleDeleteOnlyOne(name, value);
                                                        } }, label));
                                                })) : (_jsx(Typography, { children: format &&
                                                        (format.datePicker || format.datetimePicker)
                                                        ? formatDate(filtresRow.toString(), false)
                                                        : filtresRow })) }))] }), name));
                                }) }))] })));
                }, onSubmit: function (values, _a) {
                    var resetForm = _a.resetForm;
                    handleAddFiltre(values);
                    resetForm();
                }, renderSubmit: function () { return _jsx(_Fragment, {}); } }), _jsx(Stack, __assign({ alignItems: "center" }, { children: _jsx(Button, __assign({ onClick: handleSubmit, color: "primary", startIcon: _jsx(SearchIcon, {}), disabled: isSubmitting, className: "mt-small" }, { children: "Rechercher" })) }))] }));
};
//# sourceMappingURL=FiltresV2.js.map